// extracted by mini-css-extract-plugin
export default {"container":"Section5_container__2g6oi"};